/* CUSTOM QUERIES */

import { ADMIN_PARTNER } from './schema/admin-partner'
import { ANALYSE } from './schema/analyse'
import { ANSWER } from './schema/answer'
import { API_KEY } from './schema/api-key'
import { CAREER } from './schema/career'
import { CAREER_ANALYSE } from './schema/career-analyse'
import { CRON_TTL } from './schema/cron-ttl'
import { FORM } from './schema/form'
import { INTEGRATION } from './schema/integration'
import { LOG } from './schema/log'
import { PARTNER } from './schema/partner'
import { PAYMENT } from './schema/payment'
import { PERSON } from './schema/person'
import { SPACE } from './schema/space'
import { SYSTEM } from './schema/system'
import { TRIMMED_PARTNER } from './schema/trimmed/partner'
import { TRIMMED_SPACE } from './schema/trimmed/space'
import { USER } from './schema/user'

export const fileControl = /* GraphQL */ `
  query FileControl(
    $space_id: ID
    $action: String!
    $file_name: String
    $file_content: String
    $content_type: String
    $file_path: String
  ) {
    fileControl(
      space_id: $space_id
      action: $action
      file_name: $file_name
      file_content: $file_content
      content_type: $content_type
      file_path: $file_path
    )
  }
`

// Eigenes Dokument fuer deleteFile: replaced_by kennt das Schema erst mit dem
// Backend-Deploy. Im allgemeinen fileControl-Dokument wuerde ein unbekanntes
// Argument vorher auch Liste und Download brechen.
export const fileControlDeleteFile = /* GraphQL */ `
  query FileControlDeleteFile(
    $space_id: ID
    $file_name: String
    $replaced_by: String
  ) {
    fileControl(
      space_id: $space_id
      action: "deleteFile"
      file_name: $file_name
      replaced_by: $replaced_by
    )
  }
`

export const stripeControl = /* GraphQL */ `
  query StripeControl(
    $action: String!
    $product_id: ID
    $price_id: ID
    $email: String
  ) {
    stripeControl(
      action: $action
      product_id: $product_id
      price_id: $price_id
      email: $email
    )
  }
`

export const listPartners = /* GraphQL */ `
  query ListPartners(
    $filter: ModelPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPartners(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items ${ADMIN_PARTNER}
      nextToken
    }
  }
`

export const generatePdf = /* GraphQL */ `
  query GeneratePdf(
    $team_analyse_id: ID
    $user_id: ID
    $career_id: ID
    $type: String
    $partner_user_id: ID
    $partner_id: ID
    $space_id: ID
    $show_old_ui: Boolean
    $language: String
  ) {
    generatePdf(
      team_analyse_id: $team_analyse_id
      user_id: $user_id
      career_id: $career_id
      type: $type
      partner_user_id: $partner_user_id
      partner_id: $partner_id
      space_id: $space_id
      show_old_ui: $show_old_ui
      language: $language
    )
  }
`

/**
 * Bundle-PDF: mehrere Reports in EINER Datei.
 *
 * Bewusst getrennt von `generatePdf`, weil die Antwort anders aussieht. Der alte
 * Pfad liefert `headers.Location` auf die HTML-Renderseite, dieser hier `pdf_url`
 * auf eine fertige S3-Datei. `base64: true` ist fuer Bundles Pflicht, sonst
 * antwortet das Backend mit 400.
 *
 * `document_names` sind Dateinamen aus `fileControl.listFilesForSpace`. Das
 * Backend haengt sie hinter die Reports und laesst alles weg, was kein echtes PDF
 * ist. Was fehlt, steht in `parts[].skipped` der Antwort.
 *
 * Das GraphQL-Feld heisst weiterhin `generatePdf`, deshalb braucht der Aufruf
 * `options: { origin: 'generatePdf' }`, sonst loest `query()` auf null auf.
 */
export const generatePdfBundle = /* GraphQL */ `
  query GeneratePdfBundle(
    $user_id: ID
    $career_id: ID
    $space_id: ID
    $language: String
    $types: [String]
    $document_names: [String]
    $base64: Boolean
  ) {
    generatePdf(
      user_id: $user_id
      career_id: $career_id
      space_id: $space_id
      language: $language
      types: $types
      document_names: $document_names
      base64: $base64
    )
  }
`

export const summarizeAnalyses = /* GraphQL */ `
  query SummarizeAnalyses($career_id: ID!, $force_update: Boolean) {
    summarizeAnalyses(career_id: $career_id, force_update: $force_update) {
      upadtedCareer ${CAREER}
    }
  }
`

export const synthesizeAnalyze = /* GraphQL */ `
  query SynthesizeAnalyze($career_id: ID!, $force_update: Boolean) {
    synthesizeAnalyze(career_id: $career_id, force_update: $force_update) {
      upadtedCareer ${CAREER}
      isUpdated
      analysesUsed
      __typename
    }
  }
`

export const matchMeIfYouCan = /* GraphQL */ `
  query MatchMeIfYouCan(
    $partner_id: ID
    $user_id: ID
    $career_id: ID
    $career_ids: [ID]
  ) {
    matchMeIfYouCan(
      partner_id: $partner_id
      user_id: $user_id
      career_id: $career_id
      career_ids: $career_ids
    )
  }
`

export const paymentByPartnerIdByCreatedAt = /* GraphQL */ `
  query PaymentByPartnerIdByCreatedAt(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    paymentByPartnerIdByCreatedAt(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${PAYMENT}
      nextToken
    }
  }
`

export const getSpace = /* GraphQL */ `
  query GetSpace($id: ID!) {
    getSpace(id: $id) ${SPACE}
  }
`

export const spacesByPartnerIdByUpdatedAt = /* GraphQL */ `
  query SpacesByPartnerIdByUpdatedAt(
    $partner_id: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByPartnerIdByUpdatedAt(
      partner_id: $partner_id
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${SPACE}
      nextToken
    }
  }
`

export const getPerson = /* GraphQL */ `
  query GetPerson($id: ID!) {
    getPerson(id: $id) ${PERSON}
  }
`

export const careerAnalyseByCareer = /* GraphQL */ `
  query CareerAnalyseByCareer(
    $career_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCareerAnalyseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerAnalyseByCareer(
      career_id: $career_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${CAREER_ANALYSE}
      nextToken
    }
  }
`

export const apiKeysByPartner = /* GraphQL */ `
  query ApiKeysByPartner(
    $partner_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelApiKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    apiKeysByPartner(
      partner_id: $partner_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${API_KEY}
      nextToken
    }
  }
`

export const getCareer = /* GraphQL */ `
  query GetCareer($id: ID!) {
    getCareer(id: $id) ${CAREER}
  }
`

// Nur Felder ohne Field-Level-Auth. Die Quelle einer kopierten Stelle kann zu
// einem anderen Partner gehören, dort scheitert career_analyse in CAREER.
// Aufruf mit `options: { origin: 'getCareer' }`.
export const getCareerTitle = /* GraphQL */ `
  query GetCareerTitle($id: ID!) {
    getCareer(id: $id) {
      id
      title
    }
  }
`

export const careerByPartnerByDate = /* GraphQL */ `
  query CareerByPartnerByDate(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerByPartnerByDate(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${CAREER}
      nextToken
    }
  }
`

// Zählquery für das Stellen-Limit (features/pricing/usage-queries.js). Nur die
// Felder, die countsAsActiveCareer und careerSlotDelta lesen, alle ohne
// Field-Level-Auth. Das GraphQL-Feld heißt weiterhin careerByPartnerByDate,
// deshalb braucht der Aufruf `options: { origin: 'careerByPartnerByDate' }`,
// sonst löst `query()` auf null auf.
export const careerUsageByPartnerByDate = /* GraphQL */ `
  query CareerUsageByPartnerByDate(
    $partner_id: ID!
    $filter: ModelCareerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    careerByPartnerByDate(
      partner_id: $partner_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        partner_id
        status
        archived
        is_demo
        external_custom_id
        createdAt
      }
      nextToken
    }
  }
`

export const getPartner = /* GraphQL */ `
  query GetPartner($id: ID!) {
    getPartner(id: $id) ${PARTNER}
  }
`

export const userControl = /* GraphQL */ `
  query UserControl(
    $space_id: ID
    $user_type: USER_TYPES
    $username: String
    $company_name: String
    $lead_id: ID
    $language: String
    $ref_link: String
    $referrer_link: String
    $firstname: String
    $lastname: String
    $role: String
    $groupname: String
    $email: String
    $action: String!
    $action_settings: ActionSettingsInput
  ) {
    userControl(
      space_id: $space_id
      user_type: $user_type
      username: $username
      company_name: $company_name
      lead_id: $lead_id
      language: $language
      ref_link: $ref_link
      referrer_link: $referrer_link
      firstname: $firstname
      lastname: $lastname
      role: $role
      groupname: $groupname
      email: $email
      action: $action
      action_settings: $action_settings
    )
  }
`

export const partnerControl = /* GraphQL */ `
  query PartnerControl(
    $action: String!
    $partner_id: ID
    $aivy_form_id: ID
    $email: String
    $language: String
    $href: String
  ) {
    partnerControl(
      action: $action
      partner_id: $partner_id
      aivy_form_id: $aivy_form_id
      email: $email
      language: $language
      href: $href
    )
  }
`

// Nutzungsstatistik (partnerControl-Action getUsageReport). Alias auf den
// Export-Namen, damit der query()-Wrapper das Feld unter data[query] findet.
export const getUsageReport = /* GraphQL */ `
  query GetUsageReport($action: String!, $partner_id: ID) {
    getUsageReport: partnerControl(action: $action, partner_id: $partner_id)
  }
`

// Payments der eigenen Standorte (partnerControl-Action getMySpacesPayments) für
// den Standortwechsel bei abgelaufenem Zugang. Alias wie getUsageReport.
export const getMySpacesPayments = /* GraphQL */ `
  query GetMySpacesPayments($action: String!) {
    getMySpacesPayments: partnerControl(action: $action)
  }
`

// Beispieldaten (partnerControl-Actions getSampleDataSummary, removeSampleData).
// Alias wie getUsageReport, Antwort ist AWSJSON (helpers/sample-data.js
// parseControlResult).
export const sampleDataControl = /* GraphQL */ `
  query SampleDataControl(
    $action: String!
    $partner_id: ID
    $space_ids: [ID]
    $career_ids: [ID]
    $cursor: String
  ) {
    sampleDataControl: partnerControl(
      action: $action
      partner_id: $partner_id
      space_ids: $space_ids
      career_ids: $career_ids
      cursor: $cursor
    )
  }
`

export const inviteTalent = /* GraphQL */ `
  query InviteTalent(
    $send_mail: Boolean
    $career_id: ID
    $partner_id: ID
    $partner_user_id: ID
    $firstname: String
    $lastname: String
    $email: String
    $phone: String
    $postcode: String
    $city: String
    $email_template: String
    $space_id: ID
    $language: String
    $all_challenges_unlocked: Boolean
  ) {
    inviteTalent(
      send_mail: $send_mail
      language: $language
      career_id: $career_id
      partner_id: $partner_id
      partner_user_id: $partner_user_id
      firstname: $firstname
      lastname: $lastname
      email: $email
      phone: $phone
      postcode: $postcode
      city: $city
      email_template: $email_template
      space_id: $space_id
      all_challenges_unlocked: $all_challenges_unlocked
    ) ${SPACE}
  }
`

export const sendTemplateMail = /* GraphQL */ `
  query SendTemplateMail(
    $to_addresses: [String]
    $to_user_id: ID
    $template_id: ID!
    $input: AWSJSON
    $just_return_text: Boolean
    $use_local_data: Boolean
  ) {
    sendTemplateMail(
      to_addresses: $to_addresses
      to_user_id: $to_user_id
      template_id: $template_id
      input: $input
      just_return_text: $just_return_text
      use_local_data: $use_local_data
    ) {
      subject
    }
  }
`

export const publicSqlQuery = /* GraphQL */ `
  query PublicSqlQuery($action: String, $input: AWSJSON) {
    publicSqlQuery(action: $action, input: $input) {
      Items
    }
  }
`

export const getSystem = /* GraphQL */ `
  query GetSystem($id: ID!) {
    getSystem(id: $id) ${SYSTEM}
  }
`

export const matchBatchIfYouCan = /* GraphQL */ `
  query MatchBatchIfYouCan(
    $careers: [ID]
    $users: [ID]
    $with_pre_matching: Boolean
  ) {
    matchBatchIfYouCan(
      careers: $careers
      users: $users
      with_pre_matching: $with_pre_matching
    )
  }
`

export const spaceControl = /* GraphQL */ `
  query SpaceControl(
    $action: String!
    $user_id: ID
    $space_id: ID
    $authorization_role: ROLE_NAMES
    $career_id: ID
    $cursor: String
  ) {
    spaceControl(
      action: $action
      user_id: $user_id
      space_id: $space_id
      authorization_role: $authorization_role
      career_id: $career_id
      cursor: $cursor
    )
  }
`

export const answersByOwner = /* GraphQL */ `
  query AnswersByOwner(
    $owner: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAnswerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    answersByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${ANSWER}
      nextToken
    }
  }
`
// Answers des Talents hinter einem Space. Der Resolver prüft die Rechte auf den Space,
// answersByOwner geht für Partner nur noch, bis die offene Feld-Regel auf Answer entfernt ist.
export const answersBySpace = /* GraphQL */ `
  query AnswersBySpace($space_id: ID!, $limit: Int, $nextToken: String) {
    answersBySpace(space_id: $space_id, limit: $limit, nextToken: $nextToken) {
      items ${ANSWER}
      nextToken
    }
  }
`

export const careerControl = /* GraphQL */ `
  query CareerControl(
    $action: String!
    $career_id: ID
    $from_career_id: ID
    $to_career_id: ID
  ) {
    careerControl(
      action: $action
      career_id: $career_id
      from_career_id: $from_career_id
      to_career_id: $to_career_id
    )
  }
`

export const integrationControl = /* GraphQL */ `
  query IntegrationControl(
    $action: String!
    $user_id: ID
    $space_id: ID
    $partner_id: ID
    $integration_id: ID
  ) {
    integrationControl(
      action: $action
      user_id: $user_id
      space_id: $space_id
      partner_id: $partner_id
      integration_id: $integration_id
    )
  }
`

export const listIntegrationsByPartner = /* GraphQL */ `
  query ListIntegrationsByPartner(
    $partner_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIntegrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationsByPartner(
      partner_id: $partner_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${INTEGRATION}
      nextToken
    }
  }
`

export const getForm = /* GraphQL */ `
  query GetForm($id: ID!) {
    getForm(id: $id) ${FORM}
  }
`

export const listAnalysesByPartner = /* GraphQL */ `
  query ListAnalysesByPartner(
    $partner_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAnalyseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalysesByPartner(
      partner_id: $partner_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${ANALYSE}
      nextToken
    }
  }
`

export const getAnalyse = /* GraphQL */ `
  query GetAnalyse($id: ID!) {
    getAnalyse(id: $id) ${ANALYSE}
  }
`

export const helperControl = /* GraphQL */ `
  query HelperControl(
    $user_id: ID
    $space_id: ID
    $partner_id: ID
    $eventFiredBy: ID
    $log_data: AWSJSON
    $career_id: ID
    $challenge_id: ID
    $action: String
    $text_generation_context: String
    $matching: AWSJSON
    $space_ids: [ID]
    $language: String
  ) {
    helperControl(
      user_id: $user_id
      space_id: $space_id
      partner_id: $partner_id
      eventFiredBy: $eventFiredBy
      log_data: $log_data
      career_id: $career_id
      challenge_id: $challenge_id
      action: $action
      text_generation_context: $text_generation_context
      matching: $matching
      space_ids: $space_ids
      language: $language
    )
  }
`

export const sendMail = /* GraphQL */ `
  query SendMail(
    $toAddresses: [String]
    $body: String
    $subject: String
    $source: String
  ) {
    sendMail(
      toAddresses: $toAddresses
      body: $body
      subject: $subject
      source: $source
    )
  }
`

// Test-Mail aus dem Mailvorlagen-Editor. inviteTalent baut sie wie die echte
// Mail und schickt sie an die bestätigte Login-Adresse des Aufrufers.
export const sendTestMail = /* GraphQL */ `
  query SendTestMail(
    $email_template: String!
    $subject: String!
    $data: AWSJSON!
    $career_id: ID
    $language: String
  ) {
    sendTestMail(
      email_template: $email_template
      subject: $subject
      data: $data
      career_id: $career_id
      language: $language
    )
  }
`

export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      rating
      rating_text
      message
      context
      ref_link
      version
      createdAt
      updatedAt
      __typename
    }
  }
`

export const spacesByOwner = /* GraphQL */ `
  query SpacesByOwner(
    $owner: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spacesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${TRIMMED_SPACE}
    }
  }
`

export const getTrimmedPartner = /* GraphQL */ `
  query GetTrimmedPartner($id: ID!) {
    getPartner(id: $id) ${TRIMMED_PARTNER}
  }
`

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) ${USER}
  }
`

export const listCronTTLBySourceID = /* GraphQL */ `
  query ListCronTTLBySourceID(
    $source_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCronTTLFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCronTTLBySourceID(
      source_id: $source_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${CRON_TTL}
      nextToken
    }
  }
`

export const logsBySpace = /* GraphQL */ `
  query LogsBySpace(
    $space_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsBySpace(
      space_id: $space_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${LOG}
      nextToken
      __typename
    }
  }
`

export const logsByCareer = /* GraphQL */ `
  query LogsByCareer(
    $career_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByCareer(
      career_id: $career_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${LOG}
      nextToken
      __typename
    }
  }
`

export const logsByPartner = /* GraphQL */ `
  query LogsByPartner(
    $partner_id: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    logsByPartner(
      partner_id: $partner_id
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items ${LOG}
      nextToken
      __typename
    }
  }
`

export const bedrockAgent = /* GraphQL */ `
  query BedrockAgent(
    $session_id: ID
    $prompt: String
    $current_url: String
    $company_name: String
  ) {
    bedrockAgent(
      session_id: $session_id
      prompt: $prompt
      current_url: $current_url
      company_name: $company_name
    )
  }
`
